export enum AuditType {
  CREATED = 'created',
  UPDATED = 'updated',
}
